import React from "react";
import HeaderComponent from "./header";

const Header = ({ title }) => {
  return (
    <>
      <HeaderComponent  title = {title}  />
    </>
  );
};

export default Header;
